import React from 'react'
import { Alert, Button, Checkbox } from 'antd'
import { ExclamationCircleFilled, FileSearchOutlined } from '@ant-design/icons'
import { ExcessRow } from './additional-requests-model'

export default function ExcessNotice({ rows, busy, onChoose, onAccept }: {
  rows: ExcessRow[]; busy: boolean; onChoose: (rows: ExcessRow[]) => void; onAccept?: (line: number, accepted: boolean) => void
}) {
  const pending = rows.filter(row => row.excess)
  const absent = rows.filter(row => ['no_request', 'ambiguous_variant'].includes(row.issue_code || ''))
  if (!pending.length && !absent.length) return null
  return <>
    {!!absent.length && <Alert className="supply-excess" type="warning" showIcon
      message={`Уточните основания для товаров: ${absent.length}`}
      description={<>
        <p>Для части товаров нет открытой заявки или найдено несколько исполнений. Можно подобрать существующие заявки для всех товаров одним действием. В окне отправки ERP отдельно покажет непокрытое количество и проверит возможность создания автоматической заявки.</p>
        <details className="supply-excess__details" open={!!onAccept}><summary>Показать товары</summary><div className="supply-excess__scroll"><table><thead><tr><th>Товар</th><th>Пришло</th><th>Что уточнить</th></tr></thead><tbody>
          {absent.map(row => <tr key={row.line}><td>{row.line}. {row.name}</td><td>{row.actual} {row.unit}</td><td>{row.issue_code === 'ambiguous_variant' ? 'Выберите точное исполнение товара' : 'Открытая заявка не найдена'}</td></tr>)}
        </tbody></table></div></details>
        <Button icon={<FileSearchOutlined />} disabled={busy} onClick={() => onChoose(absent)}>Подобрать заявки для товаров</Button>
      </>} />}
    {!!pending.length && onAccept && <section className="supply-excess-table" aria-label="Товары с излишком">
      <div className="supply-excess-table__header">
        <div><ExclamationCircleFilled /><strong>Излишек · {pending.length}</strong></div>
        <Button type="link" icon={<FileSearchOutlined />} disabled={busy} onClick={() => onChoose(pending)}>Подобрать заявки</Button>
      </div>
      <div className="supply-excess-table__scroll"><table>
        <thead><tr><th scope="col">Товар</th><th scope="col">Пришло</th><th scope="col">По заявкам</th><th scope="col">Излишек</th><th scope="col">Принять</th></tr></thead>
        <tbody>{pending.map(row => <tr key={row.line}>
          <td>{row.line}. {row.name}</td>
          <td>{row.excess!.actual} {row.excess!.unit}</td>
          <td>{row.excess!.covered} {row.excess!.unit}</td>
          <td className="supply-excess-table__difference">{row.excess!.quantity} {row.excess!.unit}</td>
          <td><Checkbox aria-label={`Принять с излишком: строка ${row.line}, ${row.name}`} disabled={busy} checked={!!row.excess!.approved} onChange={event => onAccept(row.line, event.target.checked)}>Принять с излишком</Checkbox></td>
        </tr>)}</tbody>
      </table></div>
      <p>Отдельная заявка на излишек не создаётся.</p>
    </section>}
    {!!pending.length && !onAccept && <Alert className="supply-excess" type="warning" showIcon
    message={pending.length === 1 ? 'Пришло больше, чем указано в заявках' : `Излишек по товарам: ${pending.length}`}
    description={<>
      <div className="supply-excess__items">
        {pending.map(row => <div className="supply-excess__item" key={row.line}>
          <div className="supply-excess__product">{row.line}. {row.name}</div>
          <div className="supply-excess__quantities">
            <span>Пришло <strong>{row.excess!.actual} {row.excess!.unit}</strong></span>
            <span>По заявкам <strong>{row.excess!.covered} {row.excess!.unit}</strong></span>
            <span className="supply-excess__difference">Излишек <strong>{row.excess!.quantity} {row.excess!.unit}</strong></span>
          </div>
        </div>)}
      </div>
      <div className="supply-excess__actions">
        <Button icon={<FileSearchOutlined />} disabled={busy} onClick={() => onChoose(pending)}>Подобрать дополнительные заявки</Button>
        <span>Или примите излишек в окне отправки в 1С.</span>
      </div>
    </>} />}
  </>
}
